exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-bill-details_pay-via-mobile-switch{display:inline-block;margin-left:30px;vertical-align:top}.c-bill-details_table-price-cell{width:180px;padding-right:144px !important;text-align:right !important}.c-bill-details_table-price-cell_header{width:235px}.c-bill-details_sent-info{display:inline;margin-right:24px}.c-bill-details_sent-info svg{vertical-align:text-top;margin-right:10px}.c-bill-details_bill-dates .m-form-group{margin-right:10px}.c-bill-details_bill-dates .m-form-group_label-container{display:block}.c-bill-details_bill-dates .react-datepicker__close-icon::after{right:50px}", ""]);

// exports
